var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowTrackerMovil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 27,
    viewBox: "0 0 48 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.1245 27H0V0H37.1245C37.619 0 38.0817 0.218551 38.367 0.58766L47.7222 12.7003C48.0926 13.1795 48.0926 13.8205 47.7222 14.2997L38.367 26.4123C38.0817 26.7814 37.619 27 37.1245 27Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowTrackerMovil);
export default __webpack_public_path__ + "static/media/ArrowTrackerMovil.20d567baeccab6c04ed29dec81792fe3.svg";
export { ForwardRef as ReactComponent };